

console.clear()
console.log('addGiftIfCarttotalAt', addGiftIfCarttotalAt)
console.log('giftItem', giftItem)

async function getCartData() {
    const response = await fetch('/cart.json')
    const data = await response.json()
    console.log(data)
    return data
}




async function addFreeGiftToCart(e) {
    const cartData = await getCartData()
    let cartItems = cartData.items
    let isGiftItemAlreadyInCart = cartItems.some(item => item.handle === giftItem)


    if(cartData.total_price > addGiftIfCarttotalAt && isGiftItemAlreadyInCart === false) {
        addFreeGiftProductToCart()
    }

    if(cartData.total_price < addGiftIfCarttotalAt && isGiftItemAlreadyInCart === true) { 
        removeFreeGitItemFromCart()
    }

}



function addFreeGiftProductToCart() { 
    const freeGiftProcuctWrapper = document.querySelector('.free-gift-product')
    const freeGiftProductBtn = freeGiftProcuctWrapper.querySelector('button')
    if(freeGiftProductBtn) {
        freeGiftProductBtn.click()
    }
}


function removeFreeGitItemFromCart() { 
    const findFreeGiftItemRemoveBtn = document.querySelector('m-cart-remove-button[data-freegiftremovebutton="true"]')
    findFreeGiftItemRemoveBtn.click()
}


function addFreeGiftProduct(giftProductId) {
    const headers = new Headers({ "Content-Type": "application/json", Accept: "application/json" });

    const config = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            updates: {
                [giftProductId]: 1 // Add one gift item to the cart
            }
        }),
    };

    updateCart(config);
    console.log(updateCart(config))
}

function removeFreeGiftProduct(giftProductId) {
    const headers = new Headers({ "Content-Type": "application/json", Accept: "application/json" });

    const config = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            updates: {
                [giftProductId]: 0 // Remove the gift item from the cart
            }
        }),
    };

    updateCart(config);
}

function updateCart(request) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, request)
        .then((response) => response.json())
        .then((response) => {
            if (document.body.classList.contains("template-cart")) {
                window.location.href = MinimogSettings.routes.cart;
                return;
            }   

            const cartDrawer = document.querySelector("m-cart-drawer");
            if (cartDrawer) {
                cartDrawer.onCartDrawerUpdate();
                cartDrawer.classList.toggle("m-cart--empty", response.item_count === 0);
                MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
            }

            document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: response } }));
        })
        .catch((e) => {
            console.error(e);
        });
}
